module.exports = __webpack_public_path__ + "img/menubanner.ef2ef575.jpg";